import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IApiInstallGet } from '../ApiTypes';
import LogoFW from '../components/LogoFW';
import gstyle from '../style/style.scss';

function InstallPage() {
  const [installApiContext, setInstallApiContext] = useState<IApiInstallGet | null>(null);
  const navigate = useNavigate();
  const divLog = useRef<HTMLDivElement>(null);

  function triggerInstall() {
    console.log('Uruchom instalacje');
    fetch('/api/v1/install/', { method: 'POST' });
  }

  useEffect(() => {
    let isInstallTriggered = false;
    let lastIsInstalled = true;
    const loop = setInterval(() => {
      fetch('/api/v1/install/')
        .then((r) => r.json())
        .then((data: IApiInstallGet) => {
          setInstallApiContext(data);
          if (data.isInstalling) {
            isInstallTriggered = true;
          }
          if (!isInstallTriggered) {
            isInstallTriggered = true;
            triggerInstall();
          }
          if (lastIsInstalled === false && data.isInstalled === true) {
            console.log('Aktualizacja zainstalowana, przejdz do aplikacji');
            navigate('/app');
          }
          lastIsInstalled = data.isInstalled;
        });
    }, 3000);

    return () => {
      clearInterval(loop);
    };
  }, []);

  useLayoutEffect(() => {
    if (divLog !== null) {
      if (divLog.current) {
        divLog.current.scrollTop = divLog.current.scrollHeight;
      }
    }
  });

  return (
    <div className={gstyle.fwcontainer}>
      <LogoFW />
      <div className="mb-5" />
      <h1 className="display-1 text-center">Synchronizacja bazy danych</h1>
      <div className="mb-5" />
      <div>
        Synchronizacja potwa około 5min
        <br />
        lub więcej w zależności od prędkości łącza
      </div>

      <div className={gstyle.logi_textarea} ref={divLog}>
        {installApiContext && installApiContext.log.join('\n')}
      </div>

      {installApiContext && (
        <div className="mt-2" style={{ textAlign: 'left' }}>
          <div>
            <span>Zainstalowane: </span>
            <span>{installApiContext.isInstalled ? 'Tak' : 'Nie'}</span>
          </div>
          <div>
            <span>Instalacja: </span>
            <span>{installApiContext.isInstalling ? 'W toku' : 'Nie uruchomiono'}</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default InstallPage;
